document.addEventListener("DOMContentLoaded", () => {
  const pageURL = window.location.href;
  if (pageURL.includes("form_type=customer")) {
    document.querySelector(".newsletter-form").innerHTML +=
      '<p class="newsletter-form__message newsletter-form__message--success form__message" id="Newsletter-success--template--14504171962471__d930c4f2-4898-4bf7-9884-6cc568480a38" tabindex="-1" autofocus=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-success" viewBox="0 0 13 13"><path d="M6.5 12.35C9.73087 12.35 12.35 9.73086 12.35 6.5C12.35 3.26913 9.73087 0.65 6.5 0.65C3.26913 0.65 0.65 3.26913 0.65 6.5C0.65 9.73086 3.26913 12.35 6.5 12.35Z" fill="#428445" stroke="white" stroke-width="0.7"></path><path d="M5.53271 8.66357L9.25213 4.68197" stroke="white"></path><path d="M4.10645 6.7688L6.13766 8.62553" stroke="white"></path></svg> This email is already subscribed</p>';
  }

  if (window.innerWidth >= 750) {
    const collectionFiltersContainer = document.querySelector(".collection-line-container");
    if (collectionFiltersContainer && collectionFiltersContainer.offsetHeight != 82) {
      const mobileFilters = document.querySelector(".collection-filters-filter-all");
      mobileFilters.classList.remove("show-mobile");

      const desktopFilters = document.querySelectorAll(
        ".collection-filters-filter:not(.collection-filters-filter-all)"
      );
      for (let i = 0; i < desktopFilters.length; ++i) {
        desktopFilters[i].classList.add("hidden");
      }
    }
  }

  // Collection page - scroll to collection container when filters/sort are applied
  const urlParams = new URLSearchParams(window.location.search);
  const hasFilters = urlParams.has('filter.v.price.gte') ||
    urlParams.has('filter.v.price.lte') ||
    Array.from(urlParams.keys()).some(key => key.startsWith('filter.') && key !== 'filter.v.availability');
  const hasSort = urlParams.has('sort_by');

  if (hasFilters || hasSort) {
    // Add delay to wait for page content to fully render and prevent white flash
    setTimeout(() => {
      const collectionContainer = document.querySelector('.collection-container');
      if (collectionContainer) {
        // Get header and announcement bar heights to position collection container right below them
        const header = document.querySelector('header') || document.querySelector('.header') || document.querySelector('#shopify-section-header');
        const announcementBar = document.querySelector('#shopify-section-announcement-bar');
        
        const headerHeight = header ? header.offsetHeight : 0;
        const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
        const buffer = 20; // Add extra buffer to ensure header doesn't cover content
        const totalTopOffset = headerHeight + announcementBarHeight + buffer;
        
        // Calculate the target scroll position
        const containerTop = collectionContainer.offsetTop;
        const targetScrollPosition = containerTop - totalTopOffset;
        
        // Smooth scroll to position the collection container right below the header and announcement bar
        window.scrollTo({
          top: containerTop,
          behavior: 'smooth'
        });
      }
    }, 500); // 500ms delay to ensure page is fully rendered
  }
});

$(document).ready(() => {
  $(".read-more-explain").on("click", function () {
    const $this = $(this);
    const readMoreWrap = $(".read-more-wrap");
    const readMoreFull = $(".read-more-full");
    const readMoreDots = $(".read-more-dots");

    if (readMoreFull.hasClass("hidden")) {
      readMoreDots.addClass("hidden");
      readMoreFull.removeClass("hidden");
      $this.text("Read Less");
    } else {
      readMoreFull.addClass("hidden");
      readMoreDots.removeClass("hidden");
      $this.text("Read More");
    }

    return false;
  });

  // ---- Pagination with top-off for hidden products ----
  // Products hidden by Liquid (sold out / color filter) are replaced by
  // pulling items from a pre-fetch buffer backed by Shopify Search & Discovery
  // pages. The visible count always matches the "Products per page" setting;
  // Load More adds exactly that many more. No product is ever shown twice.

  const $collectionGrid = $(".collection #product-grid");
  const productsPerPage = parseInt($collectionGrid.data("products-per-page")) || 16;
  const sectionId = $collectionGrid.data("id") || null;
  let _productBuffer = []; // fetched-but-not-yet-shown items: [{ el, id }]
  let _nextFetchUrl = null;
  let _fetchInProgress = false;

  function restoreState() {
    const state = history.state;
    if (state && state.loadedHtml) {
      $(".collection #product-grid").html(state.loadedHtml);
      _nextFetchUrl = state.nextFetchUrl !== undefined
        ? state.nextFetchUrl
        : (state.nextPage || null);

      _productBuffer = [];
      if (Array.isArray(state.bufferedItems)) {
        const tmp = document.createElement("div");
        for (const { html, id } of state.bufferedItems) {
          tmp.innerHTML = html;
          if (tmp.firstElementChild) {
            _productBuffer.push({ el: tmp.firstElementChild, id });
          }
        }
      }

      const hasMore = _productBuffer.length > 0 || _nextFetchUrl !== null;
      if (hasMore) {
        $(".collection .pagination-load-more").show();
      } else {
        $(".collection .pagination-load-more").hide();
      }
      $(window).scrollTop(state.scrollPosition);
      return true;
    }
    return false;
  }

  function saveState() {
    const hasMore = _productBuffer.length > 0 || _nextFetchUrl !== null;
    const state = {
      loadedHtml: $(".collection #product-grid").html(),
      nextFetchUrl: _nextFetchUrl,
      bufferedItems: _productBuffer.map(({ el, id }) => ({ html: el.outerHTML, id })),
      scrollPosition: $(window).scrollTop(),
    };
    history.replaceState(state, document.title, window.location.href);
    if (hasMore) {
      $(".collection .pagination-load-more").show();
    } else {
      $(".collection .pagination-load-more").hide();
    }
  }

  function _getSeenIds() {
    const ids = new Set();
    $(".collection #product-grid [data-product-id]").each(function () {
      const id = $(this).attr("data-product-id");
      if (id) ids.add(id);
    });
    return ids;
  }

  function _fetchPage(url, seenIds) {
    return new Promise((resolve) => {
      if (!url) { resolve({ items: [], nextUrl: null }); return; }
      const fetchUrl = sectionId
        ? url + (url.includes('?') ? '&' : '?') + 'section_id=' + sectionId
        : url;
      $.get(fetchUrl, (data) => {
        const $html = $(data);
        let nextUrl = null;
        const lmHref = $html.find(".collection .pagination-load-more a").attr("href");
        const isHref = $html.find(".collection [data-pagination-infinitive-scroll]").attr("data-pagination-infinitive-scroll");
        if (lmHref && lmHref !== "#") nextUrl = lmHref;
        else if (isHref && isHref !== "#") nextUrl = isHref;

        const items = [];
        $html.find(".collection #product-grid li.grid__item").each(function () {
          const id = $(this).find("[data-product-id]").attr("data-product-id");
          if (!id || !seenIds.has(id)) items.push({ el: this, id });
        });
        resolve({ items, nextUrl });
      }).fail(() => resolve({ items: [], nextUrl: null }));
    });
  }

  // Refill _productBuffer from the next S&D page when it is empty.
  async function _ensureBuffer(seenIds) {
    if (_productBuffer.length > 0 || !_nextFetchUrl || _fetchInProgress) return;
    _fetchInProgress = true;
    try {
      const { items, nextUrl } = await _fetchPage(_nextFetchUrl, seenIds);
      _nextFetchUrl = nextUrl;
      _productBuffer.push(...items);
    } finally {
      _fetchInProgress = false;
    }
  }

  // Append exactly `count` items to the grid, fetching pages as needed.
  async function _addToGrid(count, seenIds) {
    let added = 0;
    while (added < count) {
      if (_productBuffer.length === 0) {
        await _ensureBuffer(seenIds);
        if (_productBuffer.length === 0) break; // no more products
      }
      const { el, id } = _productBuffer.shift();
      if (id && seenIds.has(id)) continue; // safety dedup
      $(".collection #product-grid").append(el);
      if (id) seenIds.add(id);
      added++;
    }
  }

  // Fill the current page up to productsPerPage (handles hidden products on load).
  async function _topOff() {
    if (!$collectionGrid.length) return;
    const seenIds = _getSeenIds();
    const needed = productsPerPage - $collectionGrid.find("li.grid__item").length;
    if (needed > 0) await _addToGrid(needed, seenIds);
  }

  // Load exactly productsPerPage more items (Load More / infinite scroll).
  async function _loadMore() {
    const seenIds = _getSeenIds();
    await _addToGrid(productsPerPage, seenIds);
  }

  // Initialize on page load
  const _stateRestored = restoreState();
  if (!_stateRestored) {
    const lmHref = $(".collection .pagination-load-more a").attr("href");
    const isHref = $(".collection [data-pagination-infinitive-scroll]").attr("data-pagination-infinitive-scroll");
    if (lmHref && lmHref !== "#") _nextFetchUrl = lmHref;
    else if (isHref && isHref !== "#") _nextFetchUrl = isHref;

    _topOff().then(() => {
      saveState();
      if (typeof colorSwatches === "function") colorSwatches();
      // Pre-warm the buffer so the first Load More click is instant.
      // Users typically spend several seconds browsing page 1 — enough
      // time for this background fetch to complete before they scroll down.
      if (_nextFetchUrl) _ensureBuffer(_getSeenIds());
    });
  }

  // Load More button
  $(".collection .pagination-load-more a").on("click", async function (event) {
    event.preventDefault();
    const loading = $(".loading-overlay__spinner", $(this));
    const text = $("span", $(this));
    loading.removeClass("hidden");
    text.addClass("hidden");

    await _loadMore();
    saveState();
    if (typeof colorSwatches === "function") colorSwatches();

    text.removeClass("hidden");
    loading.addClass("hidden");
    return false;
  });

  window.addEventListener("beforeunload", saveState);
  $("a").on("click", function () { saveState(); });

  // Infinite scroll
  let trigger = document.querySelector(".collection [data-pagination-infinitive-scroll]");
  const observer = new IntersectionObserver(
    async (entries) => {
      if (!entries[0].isIntersecting) return;
      const loading = $(".loading-overlay__spinner", $(trigger));
      loading.removeClass("hidden");
      await _loadMore();
      saveState();
      if (typeof colorSwatches === "function") colorSwatches();
      loading.addClass("hidden");
      if (_productBuffer.length === 0 && !_nextFetchUrl) trigger.remove();
    },
    { rootMargin: "800px 0px 800px 0px" }
  );
  if (trigger) observer.observe(trigger);

  document.addEventListener("gated:disable", function () {
    trigger = document.querySelector(".collection [data-pagination-infinitive-scroll]");
    if (trigger) observer.observe(trigger);
  });


  /*$(".collection [data-pagination-infinitive-scroll]").on("click", function () {
    const nextPage = $(this).attr("href");
    const loading = $(".loading-overlay__spinner", $(this));
    const text = $("span", $(this));

    loading.removeClass("hidden");
    text.addClass("hidden");

    $.get(nextPage, (data) => {
      const html = $(data);
      const productList = $(".collection #product-grid", html).html();
      const getNextPage = $(".collection .pagination-load-more a", html);

      $(".collection #product-grid").append(productList);

      const nextPageUrl = getNextPage.attr("href");
      if (getNextPage.length > 0 && nextPageUrl !== "#") {
        $(".collection .pagination-load-more a").attr("href", getNextPage.attr("href"));
      } else {
        $(".collection .pagination-load-more").hide();
      }

      text.removeClass("hidden");
      loading.addClass("hidden");

      colorSwatches();
    });

    return false;
  });*/

  $(".collection-filters-filter-all a").on("click", function () {
    if ($(this).hasClass("active")) {
      $("body").addClass("mobile-filters");
    } else {
      $("body").removeClass("mobile-filters");
    }
  });
  $(".collection-filters-tabs-title a").on("click", () => {
    $(".collection-filters-filter-all a").removeClass("active");
    $(".collection-filters-bar-all").slideUp(250, () => {
      $("body").removeClass("mobile-filters");
    });

    return false;
  });

  $(document).on("click", ".swiper-slide label", function () {
    const $this = $(this);
    const swiperSlide = $this.closest(".swiper-slide");
    const radioButton = $(`input[type="radio"][id="${$this.attr("for")}"]`, swiperSlide);
    radioButton.trigger("click");

    return false;
  });
});

/*document.addEventListener("DOMContentLoaded", () => {
  const CONTAINER_EL = ".collection-container.scroll-offset";
  const CLEAR_EL = "facet-remove a";
  const CLEAR_ALL_EL = ".facets .clear_filters";
  const LS = "anchor:offset";
  const ANCHOR_EL = ".collection-grid-section";
  const container = document.querySelector(CONTAINER_EL);
  const anchor = document.querySelector(ANCHOR_EL);
  let local = localStorage.getItem(LS);

  if (container) {
    // Function to save current scroll position to localStorage
    const saveScrollPosition = function () {
      if (container) {
        localStorage.setItem(LS_SCROLL_POSITION, container.scrollTop);
      }
    };

    // Function to restore the saved scroll position
    const restoreScrollPosition = function () {
      const savedPosition = localStorage.getItem(LS_SCROLL_POSITION);
      if (savedPosition && container) {
        container.scrollTo({
          top: parseInt(savedPosition, 10),
          behavior: "smooth",
        });
      }
    };
    
    // Save scroll position continuously while scrolling
    container.addEventListener("scroll", saveScrollPosition);

    // Restore scroll position when the page loads
    restoreScrollPosition();

    // Also save the position when clicking a specific button or link
    const registerAnchor = function () {
      localStorage.setItem("anchor:offset", "true");
    };
  
    const removeAnchor = function () {
      if (localStorage.getItem("anchor:offset")) {
        localStorage.removeItem("anchor:offset");
      }
    };
  
    // If needed, add other event listeners for specific actions
    container?.addEventListener(
      "click",
      (e) => {
        if (e.target.matches(".facet-remove a") || e.target.matches(".facets .clear_filters")) {
          registerAnchor();
        }
      },
      false
    );
  
    // When restoring the position, remove the anchor flag
    removeAnchor();
  }
});
*/